import usePaging from "../../../hooks/usePaging";
import { useGetAssessmentsPendingQuery } from "../assessmentsSlice";
import { useLocation } from "react-router-dom";
import useHasAccess from "../../../hooks/useHasAccess";

const useAssessmentsPending = () => {
  const { activePage } = usePaging({});
  const location = useLocation();
  const hasAccess = useHasAccess({
    apiCall: "assessments.GET",
  });

  const assessments = useGetAssessmentsPendingQuery(
    {
      page: location?.pathname?.includes("assessments_pending")
        ? activePage
        : 1,
    },
    {
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }
  );

  return {
    ...assessments,
    data: assessments?.data?.response,
    pagination: assessments?.data?.pagination,
    hasAccess,
  };
};

export default useAssessmentsPending;
